(function() {
  if (window.__lpAtcReady) return;
  window.__lpAtcReady = true;

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.js-lp-atc');
    if (!btn || btn.disabled) return;

    var variantId    = btn.getAttribute('data-variant-id');
    var discountCode = btn.getAttribute('data-discount-code');
    var redirectPath = btn.getAttribute('data-discount-redirect') || '/cart';

    if (!variantId) return;

    var textEl    = btn.querySelector('.js-lp-atc-text');
    var loadingEl = btn.querySelector('.js-lp-atc-loading');
    var errorEl   = btn.parentElement && btn.parentElement.querySelector('.js-lp-atc-error');

    function setLoading(on) {
      btn.disabled = on;
      if (textEl) textEl.style.display = on ? 'none' : 'inline';
      if (loadingEl) loadingEl.style.display = on ? 'inline' : 'none';
    }

    function openCart() {
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
    }

    setLoading(true);
    if (errorEl) errorEl.style.display = 'none';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
      .then(function(res) {
        if (!res.ok) return res.json().then(function(err) { throw new Error(err.description || 'Unable to add to cart.'); });
        return res.json();
      })
      .then(function(addedItem) {
        if (discountCode) {
          return fetch('/discount/' + encodeURIComponent(discountCode) + '?redirect=' + encodeURIComponent(redirectPath), { credentials: 'include' })
            .catch(function() {})
            .then(function() { return addedItem; });
        }
        return addedItem;
      })
      .then(function() {
        setLoading(false);
        openCart();
      })
      .catch(function(err) {
        setLoading(false);
        if (errorEl) {
          errorEl.textContent = err.message;
          errorEl.style.display = 'block';
        }
      });
  });
})();
